/**
 * These are useful DI module that works great with retax.
 * You DON'T HAVE to use them. You could just create your own modules in your project.
 */

export { default as componentsModule } from './components';
